/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Col, Row, Label, Input, InputGroup, InputGroupAddon, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Alert from 'react-s-alert';
import { Prompt } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import ProviderService from '../../../services/ProviderService';
import AuthService from '../../../services/AuthService';
import GeneralService from '../../../services/GeneralService';
import DemoService from '../../../services/DemoService';

// import local
import Male from '../../../assets/maleSuggestion.png';
import Female from '../../../assets/femaleSuggestion.jpg';
import Message from '../../general/Message';
import ErrorBoundary from '../../general/ErrorBoundary';
import FullPageLoader from '../../general/FullPageLoader';
import ProviderNavbar from './ProviderNavbar';
import listOfStates from '../../../assets/listOfStates.json';
import listOfCities from '../../../assets/listOfCities.json';
import { counsellors, siteVariable } from '../demoData';

const ProviderProfile = props => {

    let timeout = 0;

    // contexts
    const { theme, fontSize, colors, fontFamily } = useContext(ThemeContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [titles, setTitles] = useState([]);
    const [modal, setModal] = useState(false);
    const [filteredCities, setFilteredCities] = useState(listOfCities);
    const [provider, setProvider] = useState({
        languages: [],
        specialities: [],
        degrees: [],
        providerUniqueId: ''
    });
    const [isDataModified, setIsDataModified] = useState(false);
    const [otp, setOtp] = useState();
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [oldPhone, setOldPhone] = useState();
    const [disablePhone, setDisablePhone] = useState(true);
    const [loading, setLoading] = useState(true);
    const [specialitiesSuggestion, setSpecialitiesSuggestion] = useState([]);
    const [languagesSuggestion, setLanguagesSuggestion] = useState([]);
    const [isError, setIsError] = useState({
        message: {
            msgBody: "",
            msgError: false
        }
    });
    const [providerIDNote, setProviderIDNote] = useState(false);
    const [isProviderIDAvailable, setIsProviderIDAvailable] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Manage your profile details from here!</h2>,
                placement: 'center',
                target: '#providerProfileDiv',
            }
        ]
    });
    let helpers = null;
    const [notifications, setNotifications] = useState({
        incompleteProfile: []
    });
    const [profileComplete, setProfileComplete] = useState({
        status: true,
        message: {
            msgBody: [`Please complete your profile to enjoy our service. Unless your profile is completed you won't be visible to any clients.`],
            msgError: true
        }
    });

    // useEffects
    useEffect(() => {
        if (isError.message.msgError) {
            window.scrollTo(0, 0);
        }
    }, [isError.message]);

    useEffect(() => {
        setLoading(true);
        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles.includes("DemoProvider")) {
                    setUser(data.user);
                    if (!data.user.demoTakenFor.includes("ProviderProfile")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                    setTitles(siteVariable.userTitles);
                    setSpecialitiesSuggestion(siteVariable.providerSpecialities.filter(item => !counsellors[0].specialities.includes(item)));
                    setLanguagesSuggestion(siteVariable.providerLanguages.filter(item => !counsellors[0].languages.includes(item)));
                    setOldPhone(counsellors[0].phone);
                    setProvider(counsellors[0]);
                    setLoading(false);
                } else {
                    // props.history.replace('PagePath');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })
        return () => {
            window.onbeforeunload = undefined
            setIsDataModified(false);
        }
    }, []);

    useEffect(() => {
        if (isDataModified) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = undefined
        }
    }, [isDataModified]);

    // handle functions
    const handleProviderIDChange = e => {
        try {
            let pID = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setIsProviderIDAvailable(pID)
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderIDChange handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleChange = e => {
        try {
            setProvider({ ...provider, [e.target.name]: e.target.value });
            setIsDataModified(true);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleChange', 'Error in try catch block', err.stack);
        }
    }

    const openImageSelector = e => {
        document.getElementById("imageInput").click();
    }

    const handleImageChange = e => {
        try {
            let file = document.getElementById("imageInput").files[0];
            let reader = new FileReader();

            if (!file) {
                console.log("select file")
                return;
            } else if (file.size > 3e+6) {
                Alert.info("Please select file of size less then 3mb", {
                    position: 'top-right',
                    effect: 'slide'
                });
                return;
            }

            reader.readAsDataURL(file);

            reader.onloadend = () => {
                setProvider({ ...provider, profileImage: reader.result });
                setIsDataModified(true);
                // setProfileImage(reader.result);
            };
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleImageChange', 'Error in try catch block', err.stack);
        }
    }

    const handleAddSpeciality = e => {
        try {
            let index = document.getElementById("speciality").value;
            const value = specialitiesSuggestion[index];
            let tempArray = [...specialitiesSuggestion];
            tempArray.splice(index, 1);
            if (index) {
                setProvider({ ...provider, specialities: [...provider.specialities, value] });
                setSpecialitiesSuggestion(tempArray);
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleAddSpeciality', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveSpeciality = e => {
        try {
            let index = e.target.id;
            const value = provider.specialities[index];
            let tempArray = [...provider.specialities];
            tempArray.splice(e.target.id, 1);
            if (index) {
                setProvider({ ...provider, specialities: tempArray });
                setSpecialitiesSuggestion([...specialitiesSuggestion, value]);
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleRemoveSpeciality', 'Error in try catch block', err.stack);
        }
    }

    const handleAddLanguages = e => {
        try {
            let index = document.getElementById("languages").value;
            const value = languagesSuggestion[index];
            let tempArray = [...languagesSuggestion];
            tempArray.splice(index, 1);
            if (index) {
                setProvider({ ...provider, languages: [...provider.languages, value] });
                setLanguagesSuggestion(tempArray);
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleAddLanguages', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveLanguages = e => {
        try {
            let index = e.target.id;
            const value = provider.languages[index];
            let tempArray = [...provider.languages];
            tempArray.splice(e.target.id, 1);
            if (index) {
                setProvider({ ...provider, languages: tempArray });
                setLanguagesSuggestion([...languagesSuggestion, value]);
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleRemoveLanguages', 'Error in try catch block', err.stack);
        }
    }

    const handleDegreeKeydown = e => {
        try {
            if (e.keyCode === 13) {
                e.preventDefault();
                handleAddDegree();
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleDegreeKeydown', 'Error in try catch block', err.stack);
        }
    }

    const handleAddDegree = e => {
        try {
            let element = document.getElementById("degree");
            const value = element.value;
            if (value) {
                setProvider({ ...provider, degrees: [...provider.degrees, value] });
                element.value = "";
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleAddDegree', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveDegree = e => {
        try {
            let tempArray = [...provider.degrees];
            tempArray.splice(e.target.id, 1);
            setProvider({ ...provider, degrees: tempArray });
            setIsDataModified(true);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleRemoveDegree', 'Error in try catch block', err.stack);
        }
    }

    const handleCityChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                document.getElementById("state").selectedIndex = 0;
            } else {
                const index = e.target.selectedIndex - 1;
                const stateIndex = Number(filteredCities[index].state_id);
                document.getElementById("state").selectedIndex = stateIndex;
                setProvider({ ...provider, city: filteredCities[index].name });
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleCityChange', 'Error in try catch block', err.stack);
        }
    }

    const handleStateChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                setFilteredCities(listOfCities);
            } else {
                const index = e.target.selectedIndex - 1;
                setFilteredCities(listOfCities.filter(item => item.state_id == listOfStates[index].id));
                setProvider({ ...provider, state: listOfStates[index].name });
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleStateChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSentOtp = e => {
        setIsLoading(true);
        setTimeout(() => {
            setIsOtpSent(true);
            setIsLoading(false);
        }, [1000])
    }

    const handlePhoneChange = e => {
        try {
            if (oldPhone == e) {
                setProvider({ ...provider, isPhoneVerified: true, phone: e });
            } else {
                setIsOtpSent(false);
                setOtp();
                setProvider({ ...provider, isPhoneVerified: false, phone: e });
                setIsDataModified(true);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handlePhoneChange', 'Error in try catch block', err.stack);
        }
    }

    const handlePhoneVerify = e => {
        setIsLoading(true);
        setTimeout(() => {
            setIsOtpSent(false);
            setDisablePhone(true);
            setProvider({ ...provider, isPhoneVerified: true });
            setIsDataModified(true);
            setIsLoading(false);
        }, [1500]);
    }

    const handleEditPhone = e => {
        try {
            setDisablePhone(false);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderProfile handleEditProfile', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (!provider.title) {
                setIsError({ message: { msgBody: "Please select title", msgError: true } });
            } else if (!provider.firstName) {
                setIsError({ message: { msgBody: "Please enter FirstName", msgError: true } });
            } else if (!provider.lastName) {
                setIsError({ message: { msgBody: "Please enter LastName", msgError: true } });
            } else if (!provider.gender) {
                setIsError({ message: { msgBody: "Please select gender", msgError: true } });
            } else if (!provider.phone) {
                setIsError({ message: { msgBody: "Please enter phone", msgError: true } });
            } else if (!provider.isPhoneVerified) {
                setIsError({ message: { msgBody: "Please verify your phone", msgError: true } });
            } else if (!provider.address1) {
                setIsError({ message: { msgBody: "Please enter address1", msgError: true } });
            } else if (!provider.address2) {
                setIsError({ message: { msgBody: "Please enter address2", msgError: true } });
            } else if (!provider.city) {
                setIsError({ message: { msgBody: "Please select city", msgError: true } });
            } else if (!provider.state) {
                setIsError({ message: { msgBody: "Please select state", msgError: true } });
            } else if (!provider.pincode) {
                setIsError({ message: { msgBody: "Please enter pincode", msgError: true } });
            } else if (provider.specialities.length === 0) {
                setIsError({ message: { msgBody: "Please add speciality", msgError: true } });
            } else if (provider.languages.length === 0) {
                setIsError({ message: { msgBody: "Please add language", msgError: true } });
            } else if (provider.degrees.length === 0) {
                setIsError({ message: { msgBody: "Please add degree", msgError: true } });
            } else if (!provider.description) {
                setIsError({ message: { msgBody: "Please enter description", msgError: true } });
            } else if (!provider.profileImage) {
                setIsError({ message: { msgBody: "Please select profileImage", msgError: true } });
            } else if (provider.providerUniqueId.length < 4) {
                setIsError({ message: { msgBody: "Counsellor ID must be at least 4 characters long", msgError: true } });
            } else if (!provider.socialLinkFacebook && !provider.socialLinkInstagram && !provider.socialLinkLinkedin && !provider.socialLinkMedium && !provider.socialLinkQuora && !provider.socialLinkTwitter && !provider.socialLinkYoutube) {
                setIsError({ message: { msgBody: "Please add atleast one social media link", msgError: true } });
            }
            else {
                setIsLoading2(true);
                setIsError({ message: { msgBody: "", msgError: false } });
                setTimeout(() => {
                    setUser({ ...user, username: `${provider.title} ${provider.firstName} ${provider.lastName}`, profileImage: provider.profileImage });
                    Alert.info("Profile updated successfully", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsDataModified(false);
                    setIsLoading2(false);
                    props.history.push('/demo/counsellor/profile')
                })
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at Provider ProviderProfile handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ProviderProfile")) {
                DemoService.markVisited("ProviderProfile");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ProviderProfile"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    // toggle functions
    const toggleCreateCounsellorID = () => {
        setProviderIDNote(!providerIDNote)
    }

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };


    let span;
    if (provider.providerIDSelected) {
        span = <span className="mx-2 my-auto" style={{ color: "#28A745" }}><i className="fas fa-check-circle"></i> ID applied</span>
    }
    else {
        if (!provider.providerUniqueId) {
            span = <span className="mx-2" style={{ color: "#FFC107" }}><i className="fas fa-exclamation-circle"></i> Enter a valid Counsellor ID</span>
        }
        else {
            if (isProviderIDAvailable) {
                span = <span className="mx-2" style={{ color: "#28A745" }}><i className="fas fa-check-circle"></i> ID available</span>
            }
            else {
                span = <span className="mx-2" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i> ID not available</span>
            }
        }

    }


    // function's return
    return (
        loading ?
            <FullPageLoader /> :
            <div id="providerProfileDiv">
                <Prompt
                    when={isDataModified}
                    message='You have unsaved changes, are you sure you want to leave?'
                />
                <ErrorBoundary errorAt="At Provider ProviderProfile ProviderNavbar">
                    <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
                </ErrorBoundary>
                <div>
                    <ErrorBoundary errorAt="At Provider ProviderProfile Joyride">
                        <Joyride
                            callback={handleJoyrideCallback}
                            continuous={true}
                            getHelpers={getHelpers}
                            run={tutorial.status}
                            scrollToFirstStep={true}
                            showProgress={false}
                            showSkipButton={false}
                            steps={tutorial.steps}
                            locale={{ last: 'Finish' }}
                            styles={{
                                options: {
                                    primaryColor: "rgb(56, 78, 115)",
                                    zIndex: 10000,
                                },
                            }}
                        />
                    </ErrorBoundary>
                    <div className="py-5" style={{ overflowWrap: 'anywhere' }}>
                        {profileComplete.status ? null : <Message message={profileComplete.message} />}

                        {isError.message.msgError ? <Message message={isError.message} /> : null}

                        <ErrorBoundary errorAt="At Provider ProviderProfile Form">
                            <Form onSubmit={handleSubmit}>
                                <h2 style={theme.heading}>Edit Profile</h2>
                                <br />

                                <FormGroup>
                                    <Label for="title" style={theme.formBodyText}>Title</Label>
                                    <Input type="select" name="title" id="title" style={theme.formInput} onChange={handleChange} defaultValue={""} value={provider.title} required>
                                        <option value="">Select one</option>
                                        {
                                            titles.map((item, index) => (
                                                <option key={index} value={item}>{item}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="firstName" style={theme.formBodyText}>First Name</Label>
                                    <Input type="text" name="firstName" id="firstName" style={theme.formInput} onChange={handleChange} value={provider.firstName} required />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="lastName" style={theme.formBodyText}>Last Name</Label>
                                    <Input type="text" name="lastName" id="lastName" style={theme.formInput} onChange={handleChange} value={provider.lastName} required />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="email" style={theme.formBodyText}>Email</Label>
                                    <Input type="email" name="email" id="email" value={provider.email} onChange={handleChange} disabled={true} style={theme.formInput} />
                                </FormGroup>

                                <FormGroup row className="ml-0">
                                    <legend style={theme.formBodyText}>Gender</legend>
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="radio" name="gender" value="male" onChange={handleChange} checked={provider.gender == "male" ? true : false} />{' '}
                                            Male
                                        </Label>
                                    </FormGroup>
                                    <FormGroup className="ml-3" check>
                                        <Label check>
                                            <Input type="radio" name="gender" value="female" onChange={handleChange} checked={provider.gender == "female" ? true : false} />{' '}
                                            Female
                                        </Label>
                                    </FormGroup>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone" style={theme.formBodyText} >Phone Number </Label><br />
                                    <div className="d-inline-flex">
                                        <PhoneInput
                                            disabled={disablePhone}
                                            placeholder="+91 98765-43120"
                                            inputClass="form-control"
                                            inputStyle={theme.formInput}
                                            isValid={(value) => {
                                                if (value.slice(0, 2) !== "91") {
                                                    return false;
                                                }
                                                return true;
                                            }}
                                            inputProps={{
                                                name: 'phone',
                                                required: true
                                            }}
                                            country="in"
                                            disableDropdown={true}
                                            value={provider.phone}
                                            enableSearch={true}
                                            onChange={handlePhoneChange} />
                                        {
                                            disablePhone ?
                                                <InputGroupAddon className="pl-2" addonType="append">
                                                    <Button style={theme.formButton} onClick={handleEditPhone}>Edit</Button>
                                                </InputGroupAddon>
                                                : null
                                        }
                                        {
                                            provider.isPhoneVerified || isOtpSent ?
                                                null
                                                :
                                                <InputGroupAddon className="pl-2" addonType="append">
                                                    <Button style={theme.formButton} onClick={handleSentOtp} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Verify</Button>
                                                </InputGroupAddon>
                                        }
                                    </div>
                                    {
                                        provider.isPhoneVerified ?
                                            <p className="my-1">
                                                <i className="fas fa-check-circle" style={{ color: "#384E73" }}></i> Phone is verified
                                            </p> : null
                                    }
                                    {
                                        isOtpSent ?
                                            <div className="d-flex" style={{ marginTop: '5px' }}>
                                                <Input type="text" id="otp" name="otp" value={otp} placeholder="Enter OTP" onChange={(e) => setOtp(e.target.value)} className="form-control" style={theme.formInput} required />
                                                <Button className="ml-1" style={theme.formButton} onClick={handlePhoneVerify} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                                            </div>
                                            : null
                                    }

                                </FormGroup>

                                <FormGroup>
                                    <Label for="address1" style={theme.formBodyText}>Address</Label>
                                    <Input type="text" style={theme.formInput} name="address1" id="address" placeholder="Flat, House no. Building, Company, Apartment" onChange={handleChange} value={provider.address1} required />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="address2" style={theme.formBodyText}>Address 2</Label>
                                    <Input type="text" style={theme.formInput} name="address2" id="address2" placeholder="Area, Colony, Street, Sector, Village" onChange={handleChange} value={provider.address2} required />
                                </FormGroup>
                                <Row form>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for="city" style={theme.formBodyText}>City</Label>
                                            <Input type="select" id="city" name="city" style={theme.formInput} onChange={handleCityChange} value={provider.city} required>
                                                <option value="">Select</option>
                                                {
                                                    filteredCities.map((item) => (
                                                        <option key={item.id} value={item.name}>{item.name}</option>
                                                    ))
                                                }
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="state" style={theme.formBodyText}>State</Label>
                                            <Input type="select" id="state" name="state" style={theme.formInput} onChange={handleStateChange} value={provider.state} required>
                                                <option value="">Select</option>
                                                {
                                                    listOfStates.map((item) => (
                                                        <option key={item.id} value={item.name}>{item.name}</option>
                                                    ))
                                                }
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label for="Pincode" style={theme.formBodyText}>Pincode</Label>
                                            <Input type="text" style={theme.formInput} name="pincode" id="pincode" placeholder="123456" onChange={handleChange} value={provider.pincode} required />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <FormGroup>
                                    <Label for="country" style={theme.formBodyText}>Country</Label>
                                    <Input type="text" name="country" id="country" disabled value="India" style={theme.formInput} required />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="specialities" style={theme.formBodyText}>Specialities</Label>
                                    {
                                        provider.specialities ?
                                            provider.specialities.map((item, index) => (
                                                <InputGroup key={index} className="mb-2">
                                                    <Input type="text" value={item} disabled style={theme.formInput} />
                                                    <InputGroupAddon className="ml-2" addonType="append">
                                                        <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveSpeciality}>Remove</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            ))
                                            : null
                                    }
                                    <InputGroup hidden={specialitiesSuggestion.length === 0}>
                                        <Input type="select" id="speciality" name="specialitiesInput" style={theme.formInput}>
                                            <option value="">Select</option>
                                            {
                                                specialitiesSuggestion.map((item, index) => (
                                                    <option key={index} value={index}>{item}</option>
                                                ))
                                            }
                                        </Input>
                                        <InputGroupAddon className="ml-2" addonType="append">
                                            <Button type="button" style={{ backgroundColor: "#384E73" }} onClick={handleAddSpeciality}>Add</Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="degrees" style={theme.formBodyText} >Degrees </Label>
                                    {
                                        provider.degrees
                                            ? provider.degrees.map((item, index) => (
                                                <InputGroup key={index} className="mb-2">
                                                    <Input type="text" value={item} disabled style={theme.formInput} />
                                                    <InputGroupAddon className="ml-2" addonType="append">
                                                        <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveDegree}>Remove</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            ))
                                            : null
                                    }
                                    <InputGroup>
                                        <Input type="text" id="degree" name="degreesInput" style={theme.formInput} onKeyDown={handleDegreeKeydown}></Input>
                                        <InputGroupAddon className="ml-2" addonType="append">
                                            <Button style={{ backgroundColor: "#384E73" }} onClick={handleAddDegree}>Add</Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="languages" style={theme.formBodyText}>Languages</Label>
                                    {
                                        provider.languages ?
                                            provider.languages.map((item, index) => (
                                                <InputGroup key={index} className="mb-2">
                                                    <Input type="text" value={item} disabled style={theme.formInput} />
                                                    <InputGroupAddon className="ml-2" addonType="append">
                                                        <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveLanguages}>Remove</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            ))
                                            : null
                                    }
                                    <InputGroup hidden={languagesSuggestion.length === 0}>
                                        <Input type="select" id="languages" name="languagesInput" style={theme.formInput}>
                                            <option value="">Select</option>
                                            {
                                                languagesSuggestion.map((item, index) => (
                                                    <option key={index} value={index}>{item}</option>
                                                ))
                                            }
                                        </Input>
                                        <InputGroupAddon className="ml-2" addonType="append">
                                            <Button type="button" style={{ backgroundColor: "#384E73" }} onClick={handleAddLanguages}>Add</Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="description" style={theme.formBodyText}>Description </Label>
                                    <Input type="textarea" name="description" id="description" rows="5" value={provider.description} onChange={handleChange} required style={theme.formInput} />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="providerUniqueId" style={theme.formBodyText}>Create Counsellor ID
                                        <span> <i onClick={toggleCreateCounsellorID} style={{ color: colors.primary }} className="fas fa-question-circle"></i>
                                            {
                                                providerIDNote
                                                    ? <p className="my-2 mx-3" style={{ fontSize: fontSize.sm, display: "inline-block", margin: "auto" }}>Counsellor ID will be used to create your own unique URL Endpoint.<br></br>Note - Once setup, ID cannot be changed</p>
                                                    : null
                                            }
                                        </span></Label>

                                    <InputGroup className="row px-2">
                                        <Input className="mb-2 col-md-6 col-sm-6 col-12" type="text" name="providerUniqueId" id="providerUniqueId" style={theme.formInput} onChange={e => { handleChange(e); handleProviderIDChange(e) }} value={provider.providerUniqueId} disabled={provider.providerIDSelected} />
                                        {
                                            span
                                        }
                                    </InputGroup>
                                    <p style={{ fontFamily: fontFamily.primary, fontSize: "1rem", color: colors.primary }}>https://www.umangwellness.com/counsellors/<span style={{ fontWeight: 600 }}>{provider.providerUniqueId}</span></p>
                                </FormGroup>


                                <FormGroup>
                                    <Label style={theme.formBodyText}>Social Account Links</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Facebook</InputGroupAddon>
                                        <Input id="social-link-facebook" name="socialLinkFacebook" placeholder="www.facebook.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkFacebook}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Instagram</InputGroupAddon>
                                        <Input id="social-link-instagram" name="socialLinkInstagram" placeholder="www.instagram.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkInstagram}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Twitter</InputGroupAddon>
                                        <Input id="social-link-twitter" name="socialLinkTwitter" placeholder="www.twitter.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkTwitter}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Youtube</InputGroupAddon>
                                        <Input id="social-link-youtube" name="socialLinkYoutube" placeholder="www.youtube.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkYoutube}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Quora</InputGroupAddon>
                                        <Input id="social-link-quora" name="socialLinkQuora" placeholder="www.quora.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkQuora}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>Medium</InputGroupAddon>
                                        <Input id="social-link-medium" name="socialLinkMedium" placeholder="www.medium.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkMedium}></Input>
                                    </InputGroup>

                                    <InputGroup className="mt-3">
                                        <InputGroupAddon addonType="prepend" style={{ fontFamily: fontFamily.primary }}>LinkedIn</InputGroupAddon>
                                        <Input id="social-link-linkedin" name="socialLinkLinkedin" placeholder="www.linkedin.com/id" style={theme.formInput} onChange={handleChange} value={provider.socialLinkLinkedin}></Input>
                                    </InputGroup>
                                </FormGroup>




                                <label htmlFor="profileImageDiv" style={theme.formBodyText} >Profile Image </label>
                                <div className="row" id="profileImageDiv">
                                    <div style={{ width: "120px", height: "120px" }}>
                                        <img className="m-auto w-100 h-100" id="profileImage" src={provider.profileImage} alt="Profile Image" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                                    </div>
                                    <button className="btn mt-auto ml-3"
                                        type="button"
                                        onClick={() => setModal(true)}
                                        style={Object.assign({ height: 'fit-content' }, theme.formButton)}>Edit</button>
                                    <div style={{ visibility: 'hidden', height: '0px' }}>
                                        <input type="file" id="imageInput" accept=".jpg, .jpeg, .png" onChange={handleImageChange} />
                                    </div>
                                </div>
                                <br />
                                <Button type="submit" style={isDataModified ? theme.buttonWarning : theme.button} disabled={isLoading2}>{isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save Changes</Button>
                            </Form>
                        </ErrorBoundary>
                    </div>
                    <ErrorBoundary errorAt="At Provider ProviderProfile Modal">
                        <Modal size="sm" isOpen={modal} backdrop={true}>
                            <ModalBody>
                                <Label className="w-100 text-center" style={{ fontWeight: "600", fontSize: "1.2rem" }}>Please upload your professional headshot picture like below.</Label>
                                <div className="d-flex justify-content-around">
                                    <img src={Male} style={{ width: "120px", height: "120px", borderRadius: "50%" }} alt="MaleProfile" />
                                    <img src={Female} style={{ width: "120px", height: "120px", borderRadius: "50%" }} alt="FemaleProfile" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={() => { setModal(false); openImageSelector(); }}>Got it!</Button>
                            </ModalFooter>
                        </Modal>
                    </ErrorBoundary>
                </div>
            </div>
    )

}

export default ProviderProfile;